<script setup>
import SvgIcon from '@/components/SvgIcon/index.vue'
import {ElMessage} from 'element-plus'

defineOptions({
  name: 'HelpDoc'
})

function goto() {
  window.open('https://www.yuque.com/u1024153/icipor')
}

const visibleTour = ref(false)


/** 当前引导类型：'table' 或 'home' */
const tourType = ref('tableTour')
/** 表格通用使用指南：仅当当前页面存在 table-view 时可用 */
const startTour = (className, msg, type) => {
  if (!document.querySelector(className)) {
    ElMessage.warning(msg)
    return
  }

  tourType.value = type
  visibleTour.value = true
}


/* 引导过程中强制显示蓝色设置图标（默认鼠标悬停才显示） */
watch(visibleTour, (val) => {
  document.documentElement.classList.toggle('help-tour-visibleTour', val)
})
onUnmounted(() => {
  document.documentElement.classList.remove('help-tour-visibleTour')
})

/** 表格引导步骤配置 */
const TABLE_STEPS = [
  {
    title: '折叠搜索栏',
    target: '.show-search-bar',
    description: '点击右上角的搜索图标按钮，可以折叠/展开上方的搜索栏，为表格腾出更多展示空间。'
  },
  {title: '按需显示字段', target: '.field-config-popper__btn', description: '点击可自定义表格列，只显示你勾选的字段。'},
  {
    title: '双击行',
    target: '.el-table__body .el-table__row:first-child',
    description: '双击任意数据行，即可快速打开详情或编辑窗口（需对应权限），完成查看、编辑与新增操作。编辑时，按 Ctrl + Enter 即可保存。'
  },
  {
    title: '右键行',
    target: '.el-table__body-wrapper .el-table__row:first-child',
    description: '右键点击数据行，弹出快捷菜单，可进行预览、编辑（需对应权限）、删除（需对应权限）等常用操作。编辑时，按 Ctrl + Enter 即可保存。'
  },
  {
    title: '行内设置图标',
    target: '.el-table__body .el-table__row:first-child .row-more-btn',
    description: '将鼠标悬停到数据行上，该行会出现蓝色设置图标，点击即可展开更多操作选项。'
  },
  {
    title: '批量操作',
    target: '.table-view__tool-dropdown',
    description: '点击下拉框，可使用批量导入、导出及删除等常用操作（批量删除需先在表格中勾选数据行）。'
  }
]

/** 首页引导步骤配置 */
const HOME_STEPS = [
  {title: '首页设置弹窗', target: '.welcome-item', description: '可设置图标显隐、模块排序及尺寸。仅支持带下拉框的模块调整尺寸。'},
  {title: '图标区域', target: '.desktop-grid.m-b-10', description: '1×1 图标可自定义排序，不与大模块混排。'},
  {
    title: '图标模块',
    target: '.size-1_1:first-child',
    description: '单击跳转主页；拖拽调整位置；右键修改尺寸。非 1×1 模块自动排到底部，不混排。部分 1×1 模块不支持改尺寸，详见设置弹窗。'
  },
  {title: '卡片修改尺寸', target: '.el-card__header:first-child', description: '右键标题区域，可以修改卡片尺寸。'},
  {title: '跳转主模块', target: '.card-notice .card__more-btn', description: '点击「更多」跳转至模块主页。'},
  {title: '条目的快捷操作', target: '.card-notice .home-list__item:first-child', description: '右键点击该条目，可进行查看、编辑等操作。'},

]
/** 根据类型动态计算当前显示的步骤（过滤掉不存在的 DOM 节点） */
const currentSteps = computed(() => {
  const list = tourType.value === 'homeTour' ? HOME_STEPS : TABLE_STEPS
  return list.filter(step => !!document.querySelector(step.target))
})

const handleAddCommand = (command) => {
  let msg
  switch (command) {
    case 'help':
      url.value = 'https://www.yuque.com/u1024153/icipor/router'
      break
    case 'goto':
      goto()
      break
    case 'tableTour':
      msg = '当前页面不是表格页，请先进入任一列表页面'
      startTour('.table-view', msg, 'tableTour')
      break
    case 'homeTour':
      msg = '当前页面不是首页，请先进入首页'
      startTour('.home', msg, 'homeTour')
      break
    default:
      break
  }
}
</script>

<template>
  <div class="help-doc">
    <ElDropdown popper-class="help-dropdown" effect="dark" @command="handleAddCommand" trigger="click">
      <SvgIcon icon-class="question" style="margin-top: 7px;"/>
      <template #dropdown>
        <ElDropdownMenu effect="dark">
          <ElDropdownItem command="goto">操作文档</ElDropdownItem>
          <ElDropdownItem command="tableTour">表格使用指南</ElDropdownItem>
          <ElDropdownItem command="homeTour">首页使用指南</ElDropdownItem>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
    <ElTour v-model="visibleTour">
      <ElTourStep v-for="step in currentSteps"
                  :key="step.title"
                  :title="step.title"
                  :description="step.description"
                  :target="step.target"/>
    </ElTour>
  </div>
</template>

<style lang='scss'>
.help-doc {
  overflow: visible;

  .svg-icon {
    font-size: calc(var(--icon-size) + 3px);
    overflow: visible;
    transition: all 0.3s cubic-bezier(.36, .07, .19, .97);
  }

  &:hover {
    background: rgba(230, 162, 60, 0.1);

    .svg-icon {
      color: var(--el-color-warning);
      transform: scale(1.1) rotate(15deg);
      /* 发光效果：模拟灯泡亮起的感觉 */
      filter: drop-shadow(0 0 4px rgba(230, 162, 60, 0.6));
    }
  }
}

.help-dropdown {
  .el-dropdown-menu {
    background: unset;

    .el-dropdown-menu__item {
      color: #fff;

      &:not(.is-disabled):focus, &:not(.is-disabled):hover {
        --el-dropdown-menuItem-hover-fill: var(--el-color-primary-light-3);
      }
    }
  }

}

/* 引导过程中强制显示行尾的蓝色设置图标，便于定位引导 */
html.help-tour-visibleTour {
  .table-view__body {
    .el-table__row {
      .row-more-btn {
        display: flex;
      }
    }
  }
}
</style>
